export const UnassignedMaterialModel = {
  assignment: { type: 'assignment', col: 4, required: true },
};

export const MeteredMaterialType = {
  Water: 'Water',
  Admixture: 'Admixture',
  SecondWater: 'SecondWater',
};

export const WeighedMaterialType = {
  CoarseAggregate: 'CoarseAggregate',
  FineAggregate: 'FineAggregate',
  Cement: 'Cement',
  Cementitious: 'Cementitious',
  Water: 'Water',
  SecondWater: 'SecondWater',
};

export const MaterialType = {
  Metered: 'Metered',
  Weighed: 'Weighed',
  Other: 'Other',
  None: 'None',
};

export const ConstituentType = {
  AGGREGATE: 'AGGREGATE',
  CEMENT: 'CEMENT',
  WATER: 'WATER',
  ADMIXTURE: 'ADMIXTURE',
  UNKNOWN: 'UNKNOWN',
};

export const BayList = {
  First: 1,
  Second: 2,
  Third: 3,
};

export const BatchAction = {
  StartBatching: 'StartBatching',
  StartDischarging: 'StartDischarging',
  StartDischargingHeadWater: 'StartDischargingHeadWater',
  StartDischargingWashWater: 'StartDischargingWashWater',
  FineAggStart: 'FineAggStart',
  FineAggComplete: 'FineAggComplete',
  WaterScaleComplete: 'WaterScaleComplete',
  NoWait: 'NoWait',
  ScaleAggDischargeStart: 'ScaleAggDischargeStart',
  ScaleCemDischargeStart: 'ScaleCemDischargeStart',
  ScaleWaterDischargeStart: 'ScaleWaterDischargeStart',
  ScaleAggDischargeComplete: 'ScaleAggDischargeComplete',
  ScaleCemDischargeComplete: 'ScaleCemDischargeComplete',
  ScaleWaterDischargeComplete: 'ScaleWaterDischargeComplete',
};

export const BatchMode = {
  Auto: 'Auto',
  Manual: 'Manual',
  Skip: 'Skip',
};

export const AdmixDistribution = {
  BatchAllAdmixInFirstDrop: 'BatchAllAdmixInFirstDrop',
  BatchAdmixEvenlyDividedAcrossAllDrops: 'BatchAdmixEvenlyDividedAcrossAllDrops',
  BatchAllAdmixInLastDrop: 'BatchAllAdmixInLastDrop',
};

export const MaterialPosition = {
  One: 1,
  Two: 2,
  Three: 3,
};

export const JogType = {
  Primary: 'Primary',
  Alternate: 'Alternate',
};

export const InventoryType = {
  Shipment: 'Shipment',
  Usage: 'Usage',
  Adjustment: 'Adjustment',
};

export const InventoryPlace = {
  Plant: 'Plant',
  Location: 'Location',
};

export const UnitType = {
  Weight: 'Weight',
  WetVolume: 'WetVolume',
  DryVolume: 'DryVolume',
  Length: 'Length',
  Area: 'Area',
  Distance: 'Distance',
  Strength: 'Strength',
  Other: 'Other',
};

export const OtherMaterialModel = {
  sumBalanceForLocation: { type: 'boolean', disabled: true },
  inventoryLocationId: { hidden: true },
  inventoryPlantId: { hidden: true },
};

export const WeighedMaterialGroup = {
  BINS: 'BINS',
  MATERIAL_SETUP: 'MATERIAL SETUP',
  WEIGHING_FLOW: 'WEIGHING & FLOW',
  MOISTURE_ADJUSTMENT: 'MOISTURE & AUTO ADJUSTMENT',
  BATCH_BEHAVIOR: 'BATCH BEHAVIOR',
  DISPLAY_VISIBILITY: 'DISPLAY & VISIBILITY',
};

export const MeteredMaterialGroup = {
  PUMP: 'PUMP',
  MATERIAL_SETUP: 'MATERIAL SETUP',
  WEIGHING_FLOW: 'WEIGHING & FLOW',
  BATCH_BEHAVIOR: 'BATCH BEHAVIOR',
  DISPLAY_VISIBILITY: 'DISPLAY & VISIBILITY',
};

export const WeighedMaterialModel = {
  /**
   * HIDDEN
   */
  itemShortDescription: { type: 'text', hidden: true },
  batchCode: { type: 'text', hidden: true },
  batchShortDescription: { type: 'text', hidden: true },
  batchDescription: { type: 'text', hidden: true },
  deviceBalance: { hidden: true },
  itemBatchUnitSymbol: { type: 'itemBatchUnitSymbol', hidden: true },
  itemInventoryUnitSymbol: { type: 'itemInventoryUnitSymbol', hidden: true },
  /**
   * BINS
   */
  bins: { type: 'array', group: WeighedMaterialGroup.BINS, hideLabel: true, col: 12, defaultValue: {
    binId: null,
    isPrimary: false,
    isActive: false,
    isVisible: false,
    linkedBinId: null,
    bay: 0,
    split: 0,
  },
  },
  /**
   * MATERIAL SETUP
   */
  type: { type: 'weighedMaterialType', group: WeighedMaterialGroup.MATERIAL_SETUP, label: 'Material Type', required: true },
  itemBatchUnitId: { type: 'unit', group: WeighedMaterialGroup.MATERIAL_SETUP, option: 'symbol', label: 'Batch unit', disabled: true },
  itemInventoryUnitId: { type: 'weighedInventoryUnit', group: WeighedMaterialGroup.MATERIAL_SETUP, option: 'symbol', label: 'Inventory Unit', disabled: true },
  batchMode: { type: 'batchMode', group: WeighedMaterialGroup.MATERIAL_SETUP, required: true, defaultValue: BatchMode.Auto },
  scaleId: { type: 'decumScaleIds', group: WeighedMaterialGroup.MATERIAL_SETUP, label: 'Decum Scale' },
  position: { type: 'materialPosition', group: WeighedMaterialGroup.MATERIAL_SETUP, label: 'Material Position', dependsOn: 'scaleId' },
  specificGravity: { type: 'number', group: WeighedMaterialGroup.MATERIAL_SETUP, defaultValue: 1, min: 0.1, max: 10, disabled: true },
  vendorId: { type: 'vendor', group: WeighedMaterialGroup.MATERIAL_SETUP, option: 'code', label: 'Vendor' },
  /**
   * WEIGHING & FLOW
   */
  minimumFlowRate: { type: 'number', group: WeighedMaterialGroup.WEIGHING_FLOW, unit: ['itemBatchUnitSymbol', 'sec'], min: 0 },
  scaleSettlingTime: { type: 'number', group: WeighedMaterialGroup.WEIGHING_FLOW, label: 'Settling Time', unit: 'sec', min: 0, defaultValue: 2 },
  freeFallCloseDelay: { type: 'number', group: WeighedMaterialGroup.WEIGHING_FLOW, unit: 'sec', min: 0, defaultValue: 0 },
  aerationOff: { type: 'number', group: WeighedMaterialGroup.WEIGHING_FLOW, unit: 'itemBatchUnitSymbol', min: 0 },
  overToleranceByPercent: { type: 'number', group: WeighedMaterialGroup.WEIGHING_FLOW, label: 'Tolerance Over', unit: '%', min: 0, max: 100 },
  overToleranceByUnit: { type: 'number', group: WeighedMaterialGroup.WEIGHING_FLOW, label: 'Tolerance Over', unit: 'unit', min: 0 },
  underToleranceByPercent: { type: 'number', group: WeighedMaterialGroup.WEIGHING_FLOW, label: 'Tolerance Under', unit: '%', min: 0, max: 100 },
  underToleranceByUnit: { type: 'number', group: WeighedMaterialGroup.WEIGHING_FLOW, label: 'Tolerance Under', unit: 'unit', min: 0 },
  /**
   * MOISTURE
   */
  moistureAmount: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: '%', label: 'Total Moisture', step: 0.01, min: -100, max: 100 },
  absorption: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: '%', min: 0, max: 100 },
  freeMoisture: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: '%', label: 'Free Moisture', step: 0.01, difference: ['moistureAmount', 'absorption'], disabled: true, tooltip: 'The value is calculated based on your Total Moisture and Absorption' },
  liveMoisture: { type: 'boolean', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT },
  autoMoisture: { type: 'boolean', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT },
  autoMoistureAmount: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: '%', step: 0.01 },
  autoMoistureDelay: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: 'sec', defaultValue: 2, min: 0 },
  autoMoistureMinWeight: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: 'itemBatchUnitSymbol', defaultValue: 500 },
  autoMoistureMinAmount: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: '%', defaultValue: 0, min: 0 },
  autoMoistureMaxAmount: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: '%', defaultValue: 15, min: 0 },
  changeLimitForMoisture: { type: 'number', group: WeighedMaterialGroup.MOISTURE_ADJUSTMENT, unit: '%', defaultValue: 1, min: 1, max: 5, step: 1 },
  /**
   * BATCH BEHAVIOUR
   */
  turboBatch: { type: 'boolean', group: WeighedMaterialGroup.BATCH_BEHAVIOR },
  aggregateMode: { type: 'boolean', group: WeighedMaterialGroup.BATCH_BEHAVIOR },
  disallowBatchIfMissing: { type: 'boolean', group: WeighedMaterialGroup.BATCH_BEHAVIOR },
  jogType: { type: 'jogType', group: WeighedMaterialGroup.BATCH_BEHAVIOR, defaultValue: JogType.Primary },
  jogLimit: { type: 'number', group: WeighedMaterialGroup.BATCH_BEHAVIOR },
  maximumAmountInMix: { type: 'number', group: WeighedMaterialGroup.BATCH_BEHAVIOR, unit: 'itemBatchUnitSymbol', min: 0 },
  maximumDropLimit: { type: 'number', group: WeighedMaterialGroup.BATCH_BEHAVIOR, min: 0 },
  screwOffAmount: { type: 'number', group: WeighedMaterialGroup.BATCH_BEHAVIOR, min: 0, step: 1 },
  verification: { type: 'boolean', group: WeighedMaterialGroup.BATCH_BEHAVIOR },
  verificationMessage: { type: 'text', group: WeighedMaterialGroup.BATCH_BEHAVIOR, label: 'Verification Message', col: 12, dependsOn: 'verification' },
  batchOrder: { type: 'number', group: WeighedMaterialGroup.BATCH_BEHAVIOR, min: 0, max: 10, step: 1, defaultValue: 0 },
  batchProportionTwo: {
    group: WeighedMaterialGroup.BATCH_BEHAVIOR,
    label: 'Batch Proportion',
    type: 'number',
    unit: '%',
    proportion: true,
    min: 0,
    max: 90,
    step: 5,
    defaultValue: 0,
    tooltip: 'Splits the material into two parts and batches them in the specified order',
    dependsOn: 'type',
    dependsOnOneOf: [ WeighedMaterialType.Cementitious, WeighedMaterialType.Cement, WeighedMaterialType.FineAggregate, WeighedMaterialType.CoarseAggregate ],
  },
  batchProportionTwoOrder: {
    group: WeighedMaterialGroup.BATCH_BEHAVIOR,
    label: 'Batch Proportion Order',
    type: 'number',
    min: 0,
    max: 100,
    step: 1,
    defaultValue: 0,
    tooltip: 'Sets the order for batching the second part of the material',
    dependsOn: 'type',
    dependsOnOneOf: [ WeighedMaterialType.Cementitious, WeighedMaterialType.Cement, WeighedMaterialType.FineAggregate, WeighedMaterialType.CoarseAggregate ],
  },
  /**
   * DISPLAY
   */
  visible: { type: 'boolean', group: WeighedMaterialGroup.DISPLAY_VISIBILITY },
  showBalance: { type: 'boolean', group: WeighedMaterialGroup.DISPLAY_VISIBILITY },
  showCapacity: { type: 'boolean', group: WeighedMaterialGroup.DISPLAY_VISIBILITY },
  showReconciliation: { type: 'boolean', group: WeighedMaterialGroup.DISPLAY_VISIBILITY },
  showOnlyActiveBins: { type: 'boolean', group: WeighedMaterialGroup.DISPLAY_VISIBILITY },
  sumBalanceForLocation: { type: 'boolean', group: WeighedMaterialGroup.DISPLAY_VISIBILITY },
  alarmOn: { type: 'boolean', group: WeighedMaterialGroup.DISPLAY_VISIBILITY },
  alarmLevel: { type: 'number', group: WeighedMaterialGroup.DISPLAY_VISIBILITY, unit: 'itemInventoryUnitSymbol', dependsOn: 'alarmOn', min: 0 },
};

export const MeteredMaterialModel = {
  /**
   * HIDDEN
   */
  itemShortDescription: { type: 'text', hidden: true },
  itemBatchUnitSymbol: { type: 'itemBatchUnitSymbol', hidden: true },
  itemInventoryUnitSymbol: { type: 'itemInventoryUnitSymbol', hidden: true },

  /**
   * PUMP
   */
  pumpId: { type: 'devicePumpIds', group: MeteredMaterialGroup.PUMP, hideLabel: true },
  /**
   * MATERIAL SETUP
   */
  type: { type: 'meteredMaterialType', group: MeteredMaterialGroup.MATERIAL_SETUP, label: 'Material Type', required: true },
  itemBatchUnitId: { type: 'unit', group: MeteredMaterialGroup.MATERIAL_SETUP, option: 'symbol', label: 'Batch unit', disabled: true },
  itemInventoryUnitId: { type: 'meteredInventoryUnit', group: MeteredMaterialGroup.MATERIAL_SETUP, option: 'symbol', label: 'Inventory Unit', disabled: true },
  batchMode: { type: 'batchMode', group: MeteredMaterialGroup.MATERIAL_SETUP, required: true, defaultValue: BatchMode.Auto },
  specificGravity: { type: 'number', group: MeteredMaterialGroup.MATERIAL_SETUP, defaultValue: 1, min: 0.1, max: 10 },
  maximumAmountInMix: { type: 'number', group: MeteredMaterialGroup.MATERIAL_SETUP, unit: 'itemBatchUnitSymbol', min: 0 },
  maximumAmountInLoad: { type: 'number', group: MeteredMaterialGroup.MATERIAL_SETUP, unit: 'itemBatchUnitSymbol', min: 0 },
  meterRate: { type: 'number', group: MeteredMaterialGroup.MATERIAL_SETUP, label: 'Meter rate', min: 0.001, defaultValue: 1, step: 1 },
  vendorId: { type: 'vendor', group: MeteredMaterialGroup.MATERIAL_SETUP, option: 'code', label: 'Vendor' },
  waterPercent: { type: 'number', group: MeteredMaterialGroup.MATERIAL_SETUP, unit: '%', defaultValue: 0, min: 0, max: 100 },
  byCement: { type: 'boolean', group: MeteredMaterialGroup.MATERIAL_SETUP },
  /**
   * FLOW
   */
  minimumFlowRate: { type: 'number', group: MeteredMaterialGroup.WEIGHING_FLOW, unit: ['itemBatchUnitSymbol', 'sec'], min: 0, max: 1000, defaultValue: 0 },
  flowRateTimeout: { type: 'number', group: MeteredMaterialGroup.WEIGHING_FLOW, unit: 'sec', min: 0, max: 600, defaultValue: 0 },
  cutOff: { type: 'number', group: MeteredMaterialGroup.WEIGHING_FLOW, unit: 'itemBatchUnitSymbol' },
  autoCutOff: { type: 'boolean', group: MeteredMaterialGroup.WEIGHING_FLOW, dependsOn: 'type', dependsOnOneOf: [ MeteredMaterialType.Admixture ] },
  autoCutOffAdjustment: { type: 'number', group: MeteredMaterialGroup.WEIGHING_FLOW, dependsOn: 'type', dependsOnOneOf: [ MeteredMaterialType.Admixture ] },
  overToleranceByPercent: { type: 'number', group: MeteredMaterialGroup.WEIGHING_FLOW, label: 'Tolerance Over', unit: '%', min: 0, max: 100 },
  overToleranceByUnit: { type: 'number', group: MeteredMaterialGroup.WEIGHING_FLOW, label: 'Tolerance Over', unit: 'unit', min: 0 },
  underToleranceByPercent: { type: 'number', group: MeteredMaterialGroup.WEIGHING_FLOW, label: 'Tolerance Under', unit: '%', min: 0, max: 100 },
  underToleranceByUnit: { type: 'number', group: MeteredMaterialGroup.WEIGHING_FLOW, label: 'Tolerance Under', unit: 'unit', min: 0 },
  /**
   * BATCH
   */
  batchStart: { type: 'batchAction', group: MeteredMaterialGroup.BATCH_BEHAVIOR, required: true },
  batchStartPercent: {
    type: 'number',
    group: MeteredMaterialGroup.BATCH_BEHAVIOR,
    label: 'Batch Start %',
    min: 0,
    max: 100,
    unit: '%',
    dependsOn: 'batchStart',
    dependsOnOneOf: [
      BatchAction.FineAggStart,
      BatchAction.ScaleAggDischargeStart,
      BatchAction.ScaleCemDischargeStart,
      BatchAction.ScaleWaterDischargeStart,
    ],
  },
  batchDelay: { type: 'number', group: MeteredMaterialGroup.BATCH_BEHAVIOR, unit: 'sec', min: 0 },
  dischargeStart: { type: 'batchAction', group: MeteredMaterialGroup.BATCH_BEHAVIOR, defaultValue: BatchAction.StartDischarging },
  dischargeStartPercent: {
    type: 'number',
    group: MeteredMaterialGroup.BATCH_BEHAVIOR,
    label: 'Discharge Start %',
    min: 0,
    max: 100,
    unit: '%',
    dependsOn: 'dischargeStart',
    dependsOnOneOf: [
      BatchAction.FineAggStart,
      BatchAction.ScaleAggDischargeStart,
      BatchAction.ScaleCemDischargeStart,
      BatchAction.ScaleWaterDischargeStart,
    ],
  },
  dischargeDelay: { type: 'number', group: MeteredMaterialGroup.BATCH_BEHAVIOR, unit: 'sec', min: 0 },
  priority: {
    type: 'number',
    group: MeteredMaterialGroup.BATCH_BEHAVIOR,
    label: 'Priority',
    dependsOn: 'type',
    dependsOnOneOf:
      [ MeteredMaterialType.Admixture ],
    defaultValue: 0,
  },
  dropProportion: { type: 'admixDistribution', group: MeteredMaterialGroup.BATCH_BEHAVIOR },
  lineClearTime: { type: 'number', group: MeteredMaterialGroup.BATCH_BEHAVIOR, unit: 'sec' },
  disallowBatchIfMissing: { type: 'boolean', group: MeteredMaterialGroup.BATCH_BEHAVIOR },
  /**
   * DISPLAY
   */
  showBalance: { type: 'boolean', group: MeteredMaterialGroup.DISPLAY_VISIBILITY },
  alarmOn: { type: 'boolean', group: MeteredMaterialGroup.DISPLAY_VISIBILITY },
  alarmLevel: { type: 'number', group: MeteredMaterialGroup.DISPLAY_VISIBILITY, unit: 'itemInventoryUnitSymbol', dependsOn: 'alarmOn', min: 0 },
  verification: { type: 'boolean', group: MeteredMaterialGroup.DISPLAY_VISIBILITY },
  verificationMessage: { type: 'text', group: MeteredMaterialGroup.DISPLAY_VISIBILITY, col: 12, dependsOn: 'verification' },
  showReconciliation: { type: 'boolean', group: MeteredMaterialGroup.DISPLAY_VISIBILITY },
  sumBalanceForLocation: { type: 'boolean', group: MeteredMaterialGroup.DISPLAY_VISIBILITY },
};

export default {
  Weighed: WeighedMaterialModel,
  Metered: MeteredMaterialModel,
  None: UnassignedMaterialModel,
  Other: OtherMaterialModel,
  MaterialType: MaterialType,
  MeteredMaterialType: MeteredMaterialType,
  BatchAction: BatchAction,
  BatchMode: BatchMode,
};
